import React, { useEffect, useState } from "react";
import PaginationResult from '../../../LobbyContent/SubComponents/PaginationResult';
import { useDispatch, useSelector } from "react-redux";
import { setTotalNoResult } from "../../../../redux/actions";
import { makeAjax, url } from "../../../../helpers/global_helper";
import { withTranslation } from "react-i18next";

function SilangHomoResult(props) {
  const { startDate, endDate, submitTrigger, checkSelected, setSubmitTrigger, pageCall, pageCallFunction } = props;
  const dispatch = useDispatch();
  const country_name = useSelector((state) => state.CommonConfig.country_name);
  const [last10Result, setLast10Result] = useState([]);
  const [result, setResult] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const pageNumber = useSelector((state) => state.paginationData.pageNumber);
  const [selected, setSelected] = useState('depan');
  const [newStartDate, setNewStartDate] = useState(startDate);
  const [newEndDate, setNewEndDate] = useState(endDate);

  useEffect(() => {
    setResetPage(true);
    setLast10Result([]);
    setNewStartDate('');
    setNewEndDate('');
    fetchData();
  }, [country_name]);

  useEffect(() => {
    setNewStartDate(startDate);
    setNewEndDate(endDate);
  }, [startDate, endDate]);

  const fetchData = (page = 0) => {
    setLast10Result([]);
    const params = {
      gameId: gameId,
      page: pageNumber,
      length: 30,
      startDate: submitTrigger > 0 || page > 0 ? newStartDate : "",
      endDate: submitTrigger > 0 || page > 0 ? newEndDate : ""
    };

    makeAjax(
      url.TOGEL_API.getResultTogelNew,
      params,
      url.TOGEL_MS_EXT
    ).then((response) => {
      if (response.code === "data_not_found") {
        setLast10Result([]);
        if (page === 0 || submitTrigger > 0) {
          setSubmitTrigger();
        }
        // setSubmitTrigger();
        return;
      }
      setLast10Result(response.data.data);
      if (page === 0 || submitTrigger > 0) {
        setSubmitTrigger();
        pageCallFunction()
      }
      dispatch(setTotalNoResult(response.data.total));
    });
  }

  useEffect(() => {
    // if(submitTrigger === 1) {
    fetchData(1);
    // }
  }, [gameId, pageNumber]);

  useEffect(() => {
    // Ensure it triggers only after an actual submit
    if (submitTrigger === 1) {
      setResetPage(true);
      fetchData();
    }
  }, [submitTrigger]);

  // Function to reset the `resetPage` state back to false
  const handleResetPageNo = () => {
    setResetPage(false);
  };

  const getSilangOrHomo = (number, selectedTab) => {
    const lastFourDigits = number.slice(-4);
    let checkDigits;

    if (selectedTab === "depan") {
      checkDigits = [parseInt(lastFourDigits[0]), parseInt(lastFourDigits[1])];
    } else if (selectedTab === "tengah") {
      checkDigits = [parseInt(lastFourDigits[1]), parseInt(lastFourDigits[2])];
    } else if (selectedTab === "belakang") {
      checkDigits = [parseInt(lastFourDigits[2]), parseInt(lastFourDigits[3])];
    }
    const [first, second] = checkDigits;
    const isFirstOdd = first % 2 !== 0;
    const isSecondOdd = second % 2 !== 0;

    return isFirstOdd === isSecondOdd ? "Homo" : "Silang";
  };

  const getTranslatedDay = (day) => {
    switch (day.toLowerCase()) {
      case "monday":
        return props.t('monday');
      case "tuesday":
        return props.t('tuesday');
      case "wednesday":
        return props.t('wednesday');
      case "thursday":
        return props.t('thursday');
      case "friday":
        return props.t('friday');
      case "saturday":
        return props.t('saturday');
      case "sunday":
        return props.t('sunday');
      default:
        return day;
    }
  };

  return (
    <>
      <div className="data-analysis">
        <div className="cate-heading-2dback">
          <div
            className={`tab-item-2dback ${selected === 'depan' ? 'active' : ''}`}
            onClick={() => setSelected('depan')}
          >
            DEPAN
          </div>
          <div
            className={`tab-item-2dback ${selected === 'tengah' ? 'active' : ''}`}
            onClick={() => setSelected('tengah')}
          >
            TENGAH
          </div>
          <div
            className={`tab-item-2dback ${selected === 'belakang' ? 'active' : ''}`}
            onClick={() => setSelected('belakang')}
          >
            BELAKANG
          </div>
        </div>
        <div className="container data-table">
          <table>
            <thead>
              <tr>
                <th>No.</th>
                <th>{props.t('day')}</th>
                <th>{props.t('date')}</th>
                <th>{props.t('result')}</th>
                <th>Silang</th>
                <th>Homo</th>
              </tr>
            </thead>
            <tbody>
              {last10Result.length > 0 ? (
                last10Result.map((result, index) => {
                  const date = new Date(result.datetime);
                  const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                  const silangOrHomo = getSilangOrHomo(result.number, selected);
                  const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
                  const translatedDay = getTranslatedDay(dayName);

                  return (
                    <tr
                      key={result.period}
                      className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                      <td>{index + 1}</td>
                      {/* <td>
                        {date.toLocaleDateString("en-US", { weekday: "long" })}
                      </td> */}
                      <td>{translatedDay}</td>
                      <td>{formattedDate}</td>
                      <td>{result.number}</td>
                      <td>{silangOrHomo === "Silang" ? "✓" : ""}</td>
                      <td>{silangOrHomo === "Homo" ? "✓" : ""}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4">No results found</td>
                </tr>
              )}
            </tbody>
          </table>
          <PaginationResult resetPage={resetPage} handleResetPageNo={handleResetPageNo} />
        </div>
      </div>
    </>
  )
}

export default withTranslation()(SilangHomoResult);